document.addEventListener('DOMContentLoaded', function () {
  var productId = null;
  var productType = null;
  var accessToken = '478ee9af2b076ca2b2e341661c1f7b4f';
  var storeDomain = '/api/2023-10/graphql.json';
  var isCombined = false;
  try {
    isCombined = (productType === 'Combined') || (document.body && document.body.classList.contains('combined-product')) || ((window.learnCourseConfig||{}).productType === 'Combined');
  } catch(e) {}

  function extractNumericId(gid) {
    try { var m = gid.match(/\/(\d+)$/); return m ? m[1] : null; } catch(e) { return null; }
  }

  function disableButtons() {
    document.querySelectorAll('.add_to_cart').forEach(function(button){
      button.innerHTML = '<span class="text">Already in Cart<\/span>';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.style.backgroundColor = 'gray';
      button.style.color = 'white';
      button.style.cursor = 'not-allowed';
      button.style.pointerEvents = 'none';
      button.style.transition = 'none';
      button.style.opacity = '1';
    });
  }

  function enableButtons() {
    document.querySelectorAll('.add_to_cart').forEach(function(button){
      var label = button.getAttribute('data-label') || 'Add to Cart';
      button.innerHTML = '<span class="text">' + label + '<\/span>';
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.style.backgroundColor = '';
      button.style.color = '';
      button.style.cursor = '';
      button.style.pointerEvents = '';
      button.style.transition = '';
      button.style.opacity = '';
    });
  }

  function selectedChildHandle() {
    try {
      var sel = document.querySelector('form[action^="/cart/add"] select[name="id"]');
      if (!sel) return null;
      var vid = sel.value;
      var el = document.querySelector('.variant-data[data-variant-id="' + vid + '"]');
      if (!el) return null;
      return el.getAttribute('data-sub-product-handle') || null;
    } catch(e) { return null; }
  }

  function selectedChildSku() {
    try {
      var sel = document.querySelector('form[action^="/cart/add"] select[name="id"]');
      if (!sel) return null;
      var vid = sel.value;
      if (window.variantSkuMap && window.variantSkuMap[vid]) {
        return window.variantSkuMap[vid];
      }
      return null;
    } catch(e) { return null; }
  }

  function selectedVariantId() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = params.get('variant');
      if (fromUrl) return fromUrl;
      var sel = document.querySelector('form[action^="/cart/add"] select[name="id"]');
      if (sel && sel.value) return sel.value;
    } catch(e) {}
    return null;
  }

  function updateAddToCartButtons() {
    fetch('/cart.js')
      .then(function(response){ return response.json(); })
      .then(function(cart){
        if (!Array.isArray(cart.items)) return;
        try {
          if (isCombined) {
            var log = {
              selected: {
                handle: selectedChildHandle(),
                sku: selectedChildSku(),
                variantId: selectedVariantId()
              },
              cart: cart.items.map(function(i){ return { id: i.id, product_id: i.product_id, handle: i.handle, sku: i.sku, props: i.properties || {} }; })
            };
            // console.debug('[already-in-cart] Combined debug', log);
          }
        } catch(e) {}

        // Default check: same parent product already in cart
        var inCartByParent = cart.items.some(function(item){ return item.product_id === productId; });

        // Combined listings: check currently selected child via multiple strategies
        var inCartByChild = false;
        if (isCombined) {
          var handle = selectedChildHandle();
          var sku = selectedChildSku();
          var vid = selectedVariantId();
          if (handle || sku) {
            // 1) direct match by handle / sku on cart line
            inCartByChild = cart.items.some(function(item){
              var handleMatch = handle ? (item.handle === handle) : false;
              var skuMatch = false;
              try { skuMatch = sku ? (item.sku === sku || (item.variant_title && item.variant_title.indexOf(sku) !== -1)) : false; } catch(e) {}
              return handleMatch || skuMatch;
            });

            // 2) Variant id check against cart line variant id (items[].id)
            if (!inCartByChild && vid) {
              inCartByChild = cart.items.some(function(item){ return String(item.id) === String(vid); });
            }

            // 2b) Properties scan for child handle/sku stored by apps
            if (!inCartByChild && (handle || sku)) {
              inCartByChild = cart.items.some(function(item){
                try {
                  var props = item.properties || {};
                  var vals = Object.keys(props).map(function(k){ return String(props[k] || '').toLowerCase(); });
                  var h = handle ? handle.toLowerCase() : null;
                  var s = sku ? String(sku).toLowerCase() : null;
                  return (h && vals.some(function(v){ return v === h || v.indexOf(h) !== -1; })) || (s && vals.some(function(v){ return v === s || v.indexOf(s) !== -1; }));
                } catch(e) { return false; }
              });
            }

            // 3) if not found, resolve child product id by handle from Storefront API, then compare product_id
            if (!inCartByChild && handle) {
              var query = '{ product(handle: "' + handle.replace(/"/g,'\\"') + '"){ id } }';
              fetch(storeDomain, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': accessToken },
                body: JSON.stringify({ query: query })
              })
              .then(function(res){ return res.json(); })
              .then(function(json){
                try {
                  var gid = json && json.data && json.data.product && json.data.product.id;
                  var numericId = gid ? extractNumericId(gid) : null;
                  if (numericId) {
                    var found = cart.items.some(function(item){ return String(item.product_id) === String(numericId); });
                    if (found) disableButtons();
                  }
                } catch(e) { /* ignore */ }
              })
              .catch(function(){ /* ignore */ });
            }
          }
        }

        if (inCartByParent || inCartByChild) {
          disableButtons();
        } else {
          enableButtons();
        }
      })
      .catch(function(){ /* no-op */ });
  }

  updateAddToCartButtons();
  setTimeout(updateAddToCartButtons, 150);
  setTimeout(updateAddToCartButtons, 600);

  window.addEventListener('pageshow', function () {
    updateAddToCartButtons();
  });

  document.addEventListener('variantChanged', function(){
    updateAddToCartButtons();
  });

  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible') updateAddToCartButtons();
  });

  window.addEventListener('popstate', function(){
    updateAddToCartButtons();
  });
});